
(() => {
  const cfg = window.SA_SP || {};
  if (!cfg.endpoint) return;

  const vid = (() => {
    try {
      let v = localStorage.getItem('sa_vid');
      if (!v) {
        v = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}${Math.random().toString(36).slice(2)}`)
          .replace(/[^A-Za-z0-9_-]/g, '');
        localStorage.setItem('sa_vid', v);
      }
      return v;
    } catch (_) { return null; }  
  })();

  const send = (path, data) => {
    const url = cfg.endpoint.replace(/\/$/, '') + path;
    const body = JSON.stringify({ vid, region: cfg.region, locale: cfg.locale, ...data });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
    } catch (_) {  }
    try {
      fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body });
    } catch (_) {  }
  };

  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
  const marketingOk = () => {
    const cp = privacy();
    if (!cp) return false;
    try {
      return Boolean(cp.marketingAllowed())
        && (typeof cp.saleOfDataAllowed !== 'function' || Boolean(cp.saleOfDataAllowed()));
    } catch (_) { return false; }
  };

  const whenPrivacy = (cb) => {
    if (privacy()) { cb(); return; }
    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (privacy()) { clearInterval(t); cb(); } else if (tries > 60) clearInterval(t);
    }, 250);
  };
  const email = cfg.email ? { email: cfg.email } : {};

  if (cfg.product && vid) {
    whenPrivacy(() => {
      const fire = () => {
        if (!marketingOk()) return false;
        const seen = {
          productId: String(cfg.product.id),
          title: cfg.product.title,
          url: cfg.product.url,
          image: cfg.product.image,
          price: cfg.product.price,
          currency: cfg.product.currency,
        };
        try { localStorage.setItem('sa_last', JSON.stringify({ ...seen, at: Date.now() })); } catch (_) {  }
        send('/public/browse', { mkt: true, ...seen, ...email });
        return true;
      };

      if (!fire()) document.addEventListener('visitorConsentCollected', function once() {
        if (fire()) document.removeEventListener('visitorConsentCollected', once);
      });
    });
  }

  const bus = window.SA_BUS;
  if (bus && vid) {
    const since = Date.now();
    bus.on((ev) => {
      if (ev.name !== 'add_to_cart' || ev.at < since || !marketingOk()) return;
      const p = ev.params || {};
      const lines = Array.isArray(p.lines) && p.lines.length ? p.lines : (p.items || []).map((i) => ({
        product_id: i.item_id, title: i.item_name, variant: i.item_variant, price: i.price, quantity: i.quantity,
      }));
      if (!lines.length) return;
      send('/public/cart', {
        mkt: true,
        currency: p.currency,
        value: p.value,
        items: lines,
        ...email,
      });
    });
  }

  const okEmail = (s) => /^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(String(s || '').trim());
  const last = new WeakMap();
  const beacon = (form) => {
    if (Date.now() - (last.get(form) || 0) < 3000) return;  
    const address = (form.querySelector('[name="contact[email]"]') || {}).value || '';
    if (!okEmail(address)) return;
    last.set(form, Date.now());
    const first = ((form.querySelector('[name="contact[first_name]"]') || {}).value || '').trim();
    let seen = null;
    try {
      const l = JSON.parse(localStorage.getItem('sa_last') || 'null');
      if (l && l.productId && Date.now() - Number(l.at) < 864e5 && marketingOk()) seen = l;
    } catch (_) {  }
    send('/public/subscribe', {
      email: address.trim(), source: form.dataset.spSource,
      ...(first ? { first_name: first } : {}),
      ...(seen ? { mkt: true, last: seen } : {}),
    });
  };
  document.querySelectorAll('form[data-sp-source]').forEach((form) => {
    form.addEventListener('submit', () => beacon(form), true);
    const native = form.submit;
    form.submit = function submitWithBeacon() { beacon(this); return native.call(this); };
  });
})();
